import React, { useEffect, useState } from 'react'
import ShowComponents from '../Common/ShowComponent';
import {
  Box, Button, Card, Chip, FormControl, FormControlLabel, Grid,
  IconButton, InputAdornment, Modal, Radio, RadioGroup, Stack, TextField,
  Tooltip, Typography, Dialog, DialogActions, DialogTitle, DialogContent,
  Autocomplete
} from '@mui/material';
import { ActionButton, renderTitle } from './SarasCommonComp';
import { Colors } from '../../../../Styles/Colors';
import { DataGrid } from '@mui/x-data-grid';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import AddIcon from '@mui/icons-material/Add';
import { CommonDeleteButton, CommonEditButton, DeletePopup, useDebounce } from '../../../../Components/Common Components/CommonComponents';
import { DateTime } from 'luxon';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';

const SarasAllergies = ({ Title, ...props }) => {
  let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null
  const [postLoading, setPostLoading] = useState(false);
  const [Allerydata, setAllerydata] = useState([]);
  const [genericNameList, setGenericList] = useState([]);
  const [state, setState] = useState({
    AllergyType: 1,
    AllergyStatus: "active",
    AllergyComments: "",
    allergyNameList: [],
    AllergyName: "",
    isDeleteClicked: false,
    SelectedAllergy: "",
    NewAllergyAdd: false,
    NewAllergyName: "",
    isDeleteItem: false,
    SelectedList: {},
    SelectedId: null,
    isDeleteClicked: false,
    isConfm: false,
    isAdd: false,
    NewAllergyNameSearch:''
  })
  const debouneQuery = useDebounce(state.NewAllergyName, 500)

  const getApiCall = () => {
    getAllergyData()
    getAllergyNameList(true);
    // getGenericList()
  }

  useEffect(() => {
    if(debouneQuery && !props.fromIp){
      getGenericList()
    }else{
      setState((prev) => ({...prev,}))
    }
  },[debouneQuery])

    const getGenericList = () => {
      try {
      RestAPIService.getAll(Serviceurls.GENERIC_MASTER_SUGGESTION + '?generic_name=' + encodeURIComponent(debouneQuery))
        .then((response) => {
          if (response?.data?.status === 'success') {
            setGenericList(response.data.genric_names || [])
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            props.errorMessage(error.response.data.message)
          } else {
            props.errorMessage(error.message)
          }
        })
    } catch (error) {
      props.errorMessage(error.message)
    }
  }
  
  const getAllergyData = () => {
    try {
      setPostLoading(true)

      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_ALLERGIES + `?patient_id=${props?.PatientData?.patient_id}&doctor_id=${props?.doctor_id}`).
        then((response) => {
          if (response.data.status === "success") {
            const allergyData = response?.data?.data?.map((item, index) => ({
              ...item, sno: index + 1
            }));
            setAllerydata(allergyData || [])
            props.showAllergyData(allergyData || [])
          }
          else {
            props.errorMessage(response.data.message)
          }
        }).catch((error) => {
          props.errorMessage(error.message)
        }).finally(() => {
          setPostLoading(false)
        })
    } catch (error) {
      props.errorMessage(error?.message)
    }
  }

  const getAllergyNameList = (AddItemIfNot = false) => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_ALLERGY_FEQ)
        .then((response) => {
          if (response?.data?.status === 'success') {
            const updatedList = [...response?.data?.data || []];
            if (AddItemIfNot && state.AllergyName) {
              const isAllergy = updatedList.some(item => item === state.AllergyName);
              if (!isAllergy) {
                updatedList.push(state.AllergyName);
              }
            }
            setState(prev => ({
              ...prev,
              allergyNameList: updatedList,
            }));
          }
        }).catch((error) => {
          props.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      props.errorMessage(error.message)
    }
  }

  const PostAllergies = () => {
    try {
      if (state.AllergyType == 3 || CommonValidation.removeSpace(state.AllergyName) !== "") {
        const data = {
          appointment_id: props?.PatientData?.appointment_id,
          patient_id: props?.PatientData?.patient_id,
          allergies: {
            allergy_type: state.AllergyType,
            comments: state.AllergyComments,
            diagnosed_date: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            id: state.SelectedId ? state.SelectedId : null,
            is_active: state.AllergyStatus === "active" ? true : false,
            name: state.AllergyName
          }
        }
        if (props?.fromIp) {
                data['clinic_id'] = props?.clinicId || null
                data['ip_admission_id'] = props?.admission_id || null
                data['doctor_id'] = props?.doctor_id || null
        }

        RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_ALLERGIES)
          .then((response) => {
            if (response.data.status === "success") {
              props.successMessage(response.data.message)
              getAllergyData()
              setState((prevState) => ({
                ...prevState, isAdd: false
              }))
              ClearData()
              if (props?.fromIp) {
                props?.callHistory(true)
              }else{
                props.PrescriptonTemplate()
              }
            } else {
              props.errorMessage(response.data.message)
            }
          }).catch(error => {
            if (error?.response?.data?.status === "fail") {
              props.errorMessage(error.response.data.message)
            } else {
              props.errorMessage(error.message)
            }
          })
      } else {
        props.errorMessage("Select Allergy Name")
      }
    } catch (error) {
      props.errorMessage(error.message)
    }
  }

  const ClearData = () => {
    setState((prevState) => ({
      ...prevState,
      AllergyType: 1,
      AllergyStatus: "active",
      AllergyName: "",
      NewAllergyName: "",
      AllergyComments: "",
      NewAllergyAdd: false,
      SelectedId: null,
      isDeleteClicked: false,
      isConfm: false,
    }))
  }

  const renderAlertPop = () => {
    return (
      <Dialog
        open={state.isConfm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography fontSize={'1.2vw'}>Are You Sure?</Typography>
            <IconButton onClick={() => { setState((prevState) => ({ ...prevState, isConfm: false })) }}>
              <img src={ImagePaths.LabCloseButton.default} style={{ width: '1.2vw', height: '1.2vw' }} alt='name' />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ backgroundColor: '#FFF4E6', display: 'flex', height: '8vw', alignItems: 'center' }}>
            <img src={ImagePaths.WarAlert.default} style={{ width: '2vw', height: '2vw', marginLeft: '.5vw', marginRight: '.5vw' }} alt='name' />
            <Typography fontSize={'1vw'}>
              This patient has documented allergies previously. Do you want to update the record to indicate no allergies now?
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize' }} onClick={() => { setState((prevState) => ({ ...prevState, isConfm: false })) }}>No</Button>
          <Button size='small' variant='contained' sx={{ textTransform: 'capitalize' }} onClick={PostAllergies}>Yes</Button>
        </DialogActions>
      </Dialog>
    )
  }

  const renderAllergyAdd = () => {
    return (
      <Modal open={state.isAdd} sx={{ outline: "none" }} disableEnforceFocus>
        <Box className='eMed_Doc_Notes_Prescrip_Pop_Up'
          sx={{ width: "40dvw", height: "35dvw", display: "flex", flexDirection: "column" }}>
          <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
            <Typography fontSize={'1vw'} fontWeight={600} color={Colors.SecondaryText} padding={'1vw'}>Add Allergy</Typography>
            <IconButton>
              <img src={ImagePaths.LabCloseButton.default} alt='close' onClick={() => { setState({ ...state, isAdd: false }); ClearData(); }} style={{ width: '1vw', height: '1vw' }} />
            </IconButton>
          </Box>
          <Box sx={{ height: '28dvw', overflowY: 'auto' }}>
            <Box>
              <Typography height={'6vh'} display={'flex'} alignItems={'center'} paddingLeft={'1vw'} fontWeight={600} color={'#616161'} sx={{ backgroundColor: '#F5F8F7' }}>Allergies</Typography>
              <FormControl sx={{ marginLeft: "1vw" }}>
                <RadioGroup
                  value={state.AllergyType}
                  sx={{ display: 'flex', flexDirection: 'row' }}
                  onChange={(e) => { setState({ ...state, AllergyType: e.target.value }) }}
                >
                  <FormControlLabel value="1" control={<Radio size='small' emed_tid='medication_radio' />} label="Medication Allergy" />
                  <FormControlLabel value="2" control={<Radio size='small' />} label="Non Medication Allergy" />
                  <FormControlLabel value="3" control={<Radio size='small' />} label="No Allergy" />
                </RadioGroup>
              </FormControl>
            </Box>
            {state.AllergyType == 3 ? null : <Box>
              <Typography height={'6vh'} display={'flex'} alignItems={'center'} paddingLeft={'1vw'} fontWeight={600} color={'#616161'} sx={{ backgroundColor: '#F5F8F7' }}>Allergy Name</Typography>
              {
                state.allergyNameList?.length > 0 ? state.allergyNameList.map((item, index) => (
                  <Chip
                    size='small'
                    className={`eMed_chip ${state.AllergyName === item ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                    key={index}
                    label={item}
                    variant={state.AllergyName === item ? 'contained' : "outlined"}
                    onClick={() => { setState({ ...state, AllergyName: item }) }}
                    onDelete={() => { setState({ ...state, isDeleteClicked: true, SelectedAllergy: item }) }}
                  />
                )) : null
              }
              {state.NewAllergyAdd ?
              (state.AllergyType == 1  && !LoggedData?.show_allergy_suggetiom && !props?.fromIp) ?
                <Autocomplete
                  freeSolo
                  size="small"
                  options={genericNameList || []}
                  value={state?.NewAllergyName || null}
                  onChange={(e, newValue) => {
                    if (typeof newValue === 'string') {
                        setState((prev) => ({ ...prev, NewAllergyName: newValue }))
                    }
                  }}
                  inputValue={state?.NewAllergyName}
                  onInputChange={(e, newInputValue) => {
                     setState((prev) => ({ ...prev, NewAllergyName: e.target.value }))
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Add Allergy"
                      inputProps={{
                        ...params.inputProps,
                        maxLength: 30,
                        style: { height: "0.8vw" },
                      }}
                      sx={{ width: "10vw", marginLeft: "0.5vw", marginTop: "0.3vw" }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && state?.NewAllergyName !== "") {
                            const List = state.allergyNameList
                            if (!List.includes(state.NewAllergyName)) {
                              List.push(state.NewAllergyName);
                            }
                            else{
                              props.errorMessage("This allergy already exist")
                            }
                            setState({
                            ...state,
                            allergyNameList: List,
                            AllergyName: state.NewAllergyName,
                            NewAllergyName: "",
                            NewAllergyAdd: false
                          })
                          e.preventDefault(); // Prevents dropdown selection
                        }
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              disabled={state.NewAllergyName === ""}
                              onClick={() => {
                                const List = state.allergyNameList
                                if (!List.includes(state.NewAllergyName)) {
                                  List.push(state.NewAllergyName);
                                }
                                else{
                                  props.errorMessage("This allergy already exist")
                                }
                               setState((prev) => ({
                                ...prev,
                                allergyNameList: List,
                                AllergyName: state.NewAllergyName,
                                NewAllergyName: "",
                                NewAllergyAdd: false
                              }))
                              }}
                            >
                              <AddIcon color={state?.NewAllergyName === "" ? "grey" : "primary"} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
                : 
                <TextField
                  size='small'
                  value={state.NewAllergyName}
                  onChange={(e) => {
                    setState({
                      ...state,
                      NewAllergyName: e.target.value
                    })
                  }}
                  inputProps={{ maxLength: 30, style: { height: "0.8vw" } }}
                  sx={{ width: "10vw", marginLeft: "0.5vw", marginTop: '0.3vw' }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && state.NewAllergyName !== "") {
                      let List = state.allergyNameList
                      List.push(state.NewAllergyName)
                      setState({
                        ...state,
                        allergyNameList: List,
                        AllergyName: state.NewAllergyName,
                        NewAllergyName: "",
                        NewAllergyAdd: false
                      })
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          disabled={state.NewAllergyName === ""}
                          onClick={() => {
                            let List = state.allergyNameList
                            List.push(state.NewAllergyName)
                            setState({
                              ...state,
                              allergyNameList: List,
                              AllergyName: state.NewAllergyName,
                              NewAllergyName: "",
                              NewAllergyAdd: false
                            })
                          }}>
                          <AddIcon color={state.NewAllergyName === "" ? 'grey' : 'primary'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }} /> :
                <IconButton
                  onClick={() => {
                    setState({
                      ...state,
                      NewAllergyAdd: true
                    })
                  }}>
                  <AddIcon color={'primary'} />
                </IconButton>
              }
            </Box>}
            {state.AllergyType == 3 ? null : <Box>
              <Typography height={'6vh'} display={'flex'} alignItems={'center'} paddingLeft={'1vw'} fontWeight={600} color={'#616161'} sx={{ backgroundColor: '#F5F8F7' }}>Allergy Status</Typography>
              <FormControl sx={{ marginLeft: "1vw" }}>
                <RadioGroup
                  value={state.AllergyStatus}
                  sx={{ display: 'flex', flexDirection: 'row' }}
                  onChange={(e) => { setState({ ...state, AllergyStatus: e.target.value }) }}
                >
                  <FormControlLabel value="active" control={<Radio size='small' />} label="Active" />
                  <FormControlLabel value="inactive" control={<Radio size='small' />} label="InActive" />
                </RadioGroup>
              </FormControl>
            </Box>}
            <Box>
              <Typography height={'6vh'} display={'flex'} alignItems={'center'} paddingLeft={'1vw'} fontWeight={600} color={'#616161'} sx={{ backgroundColor: '#F5F8F7' }}>Comments</Typography>
              <TextField
                size='small'
                multiline={true}
                rows={3}
                sx={{ width: '35vw', marginLeft: '1.2vw', marginTop: '0.5vw' }}
                label={"Comments ( Max 250 characters)"}
                inputProps={{ maxLength: 250 }}
                value={state.AllergyComments}
                onChange={(e) => {
                  if (CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value) || e.target.value === "") {
                    setState({ ...state, AllergyComments: e.target.value })
                  }
                }}
              />
            </Box>
          </Box>
          <Box marginTop={'1vw'} display={'flex'} flexDirection={'row'} justifyContent={'end'} alignItems={'center'}>
            <Button size='small' variant='outlined' onClick={ClearData} sx={{ marginRight: '1vw', textTransform: 'capitalize' }}>Clear</Button>
            <Button size='small' variant='contained'
              onClick={() => {
                (state.AllergyType == 3 && props.allergyData.length > 0)
                ? setState((prevState) => ({ ...prevState, isConfm: true }))
                : PostAllergies()
              }}
              sx={{ textTransform: 'capitalize', marginRight: '1vw', }}>Save</Button>
          </Box>
        </Box>
      </Modal>
    )
  }

  const columns = [
    {
      field: "allergy_type", flex: 0.17, headerName: "Allergy Type",
      renderCell: (params) => (
        <Box component={'div'}>
          <Typography fontSize={'0.9vw'}>{params?.row?.allergy_type === 2 ? "Non Medication Allergy" : params?.row?.allergy_type === 3 ? "No Allergy" : "Medication Allergy"}</Typography>
          <Typography fontSize={'0.9vw'}>{params?.row?.diagnosed_date ? formatDate(params?.row?.diagnosed_date) : "-"}</Typography>
        </Box>
      )
    },
    {
      field: "name", flex: 0.14, headerName: "Allergy Name", headerAlign: "center", align: 'center',
      renderCell: (params) => (<Box component={'div'} fontSize={'0.9vw'}>
        {params?.row?.name ? params?.row?.name?.length > 15 ?
          <Tooltip placement='top' title={params?.row?.name} arrow>
            <div style ={{fontSize: "0.9vw"}}>{params?.row?.name.slice(0, 15) + "..."}</div></Tooltip> :
          params?.row?.name : "-"}
      </Box>)
    },
    {
      field: "is_active", flex: 0.1, headerName: "Status",
      renderCell: (params) => (<Box component={'div'}>
        <Typography color={params?.row?.is_active ? "red" : "orange"} fontSize={"0.9vw"}>{params?.row?.allergy_type === 3 ? '-' : params?.row?.is_active ? "Active" : "Inactive"}</Typography>
      </Box>)
    },
    {
      field: "comments", flex: 0.22, headerName: "Comments",
      renderCell: (params) => (<Box component={'div'} fontSize={'0.9vw'}>
        {params?.row?.comments ? params?.row?.comments?.length > 35 ?
          <Tooltip placement='top' title={params?.row?.comments} arrow>
            <div style ={{fontSize: "0.9vw"}}>{params?.row?.comments.slice(0, 35) + "..."}</div></Tooltip> :
          params?.row?.comments : "-"}
      </Box>)
    },
    {
      field: "action", flex: 0.14, headerName: "Action", headerAlign: "center", align: "center",
      renderCell: (params) => <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
        <CommonEditButton testID={"allergy_edit"} size={"1.5vw"} disable={props.isLocked || params.row.allergy_type === 3}
          onClick={onEditHandler.bind(this, params.row)}
        />
        <CommonDeleteButton testID={"allergy_delete"} size={"1.5vw"} disable={props.isLocked || state.SelectedId === params?.row?.id || params.row.allergy_type === 3}
          onClick={onDeleteHandler.bind(this, params)}
        />
      </Box>
    }
  ]

  const onEditHandler = (data) => {
    setState((prevState) => {
      const updatedAllergyName = data?.name ?? "";
      const updatedAllergyList = prevState.allergyNameList.includes(updatedAllergyName)
        ? prevState.allergyNameList
        : [...prevState.allergyNameList, updatedAllergyName];

      return {
        ...prevState,
        isAdd: true,
        AllergyType: data?.allergy_type ?? 1,
        AllergyStatus: data?.is_active ? "active" : "inactive",
        AllergyName: updatedAllergyName,
        AllergyComments: data?.comments ?? "",
        SelectedId: data?.id ?? null,
        allergyNameList: updatedAllergyList,
      };
    });
  }

  const onDeleteHandler = (data) => {
    try {
      setState((prevState) => ({
        ...prevState,
        isDeleteItem: true,
        SelectedList: data.row,
      }))
    } catch (error) {
      props.errorMessage(error.message)
    }
  }

  const DeleteAllergy = () => {
    try {
      RestAPIService.delete(Serviceurls.DOC_DOCTOR_NOTES_ALLERGY_FEQ + "?allergy=" + state.SelectedAllergy).
        then((response) => {
          if (response.data.status === "success") {
            setState((prevState) => ({
              ...prevState,
              AllergyType: 1,
              AllergyStatus: "active",
              AllergyComments: "",
              allergyNameList: [],
              AllergyName: "",
              isDeleteClicked: false,
              SelectedAllergy: "",
              NewAllergyAdd: false,
              NewAllergyName: "",
            }))
            getAllergyNameList()
          } else {
            props.errorMessage(response.data.message)
          }
        }).catch(error => {
          props.errorMessage(error?.response?.data?.message || error.message)
        })
    }
    catch (e) {
      props.errorMessage(e.message)
    }
  }

  const DeleteAllergyItem = () => {
    try {
      RestAPIService.delete(Serviceurls.DOC_DOCTOR_NOTES_ALLERGIES + `?id=${state.SelectedList?.id}`, {})
        .then((response) => {
          if (response.data.status === "success") {
            props.successMessage(response.data.message);
            setState({
              ...state,
              isDeleteItem: false,
              SelectedList: {},
            })
            setTimeout(() => {
              getAllergyData()
            }, 1000);
          } else {
            props.errorMessage(response.data.message)
          }
        }).catch(error => {
          props.errorMessage(error?.response?.data?.message || error.message)
        })
    }
    catch (e) {
      props.errorMessage(e.message)
    }
  }

  const popupClose = () => {
    setState({
      ...state,
      isDeleteClicked: false,
      isDeleteItem: false,
    })
  }

  return (
    <ShowComponents
      onIntersection={getApiCall.bind(this)}
    >
      <Card sx={{
        width: "100%", height: "fit-content", padding: "0.3vw",
        marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
      }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
          <Typography fontSize={'1vw'} fontWeight={600} color={Colors.SecondaryText}> {renderTitle(Title, props.isSelected)}</Typography>
          <Stack direction="column" sx={{ height: "7vh" }} alignItems="center" justifyContent="center">
            <Stack direction="row" spacing={2} display={"flex"} justifyContent='center' alignItems="center" mt='0.3vh'>
              <ActionButton text={"Add"} emed_tid='doc_notes_bold_clr' disabled={postLoading || props.isLocked} onClick={() => { setState({ ...state, isAdd: true }) }} />
            </Stack>
          </Stack>
        </Box>
        <Grid container>
          <Box height={'30vh'} width={'100%'}>
            <DataGrid
              rows={Allerydata}
              columns={columns}
              getRowId={(row) => row['sno']}
              headerHeight={40}
              hideFooter={true}
              components={{
                NoRowsOverlay: () => (
                  <Stack className='eMed_DocNotes_nodata'>
                    {"No Records To Be Shown"}
                  </Stack>
                )
              }}
              disableSelectionOnClick
            />
          </Box>
        </Grid>
      </Card>
      {renderAllergyAdd()}
      {renderAlertPop()}
      {state.isDeleteClicked ? <DeletePopup
        DeletTitle={`${"Are you sure you want to delete"}  ${"Allergy"} ${state.SelectedAllergy ? state.SelectedAllergy : "-"} From Frequent List ?`}
        deleteAlertPopupClose={popupClose.bind(this)}
        removeData={DeleteAllergy.bind(this)}
      /> : null}
      {state.isDeleteItem ? <DeletePopup
        DeletTitle={`${"Are you sure you want to delete"} ${"Allergy"} ${state.SelectedList ? state.SelectedList?.name : "-"} ?`}
        deleteAlertPopupClose={popupClose.bind(this)}
        removeData={DeleteAllergyItem.bind(this)}
      /> : null}
    </ShowComponents>
  );
}
export default SarasAllergies;